import { RouteType } from "types/RouteType";

const WorkflowsDashboardRoute: RouteType = {
  name: "Workflow Dashboard",
  path: "/workflows",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Workflows",
      component: () => import("./WorkflowsDashboardHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./WorkflowsDashboard"),
      grayBackground: true,
    },
  },
  beforeEnter: async () => {
    // No specific data loading required for the dashboard
    return true;
  },
};

export default WorkflowsDashboardRoute;
